module.exports = __webpack_public_path__ + "img/10.0b81d868.png";